import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import TrustedBy from './components/TrustedBy';
import About from './components/About';
import TechSolutions from './components/TechSolutions';
import Projects from './components/Projects';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Services />
      <TrustedBy />
      <About />
      <TechSolutions />
      <Projects />
      <CTA />
      <Footer />
    </div>
  );
}

export default App;
